export function AnimalGridPage () {
	return (
			<div className="container mx-auto py-8 px-4" >
				<h1 className="text-3xl font-bold mb-8" >Animal
				                                         Management
				                                         Dashboard</h1 >
				{/*<AnimalGrid />*/ }
			</div >
	)
}
